export interface IWhTaskMainProps {
  whTaskId: number;
}

export enum EWhTaskMainTabs {
  items = 'items',
  documents = 'documents',
  invoices = 'invoices',
  expenses = 'expenses',
}

export interface IWhTaskMainTabs {
  key: EWhTaskMainTabs;
  label: string;
}
